export default "__VITE_ASSET__DcYQ5fcz__"